import qs from "query-string";
import { fetchGAClientId } from "./functions";
import { FormData } from "../components/FormClient/FormClient.types";
import { SessionLayer } from "../interfaces/index";
import { CRMValue, ConfigObject, DataLayer, PushData } from "../components/FormViewer/FormViewer.types";

declare global {
  interface Window {
    sessionLayer: {
      lead: SessionLayer;
      pushToSession: (crm_field: string, crm_value: CRMValue) => void;
    };
    dataLayer: DataLayer;
    FC_CONFIG: ConfigObject;
    gtag: any;
  }
}

export const initiateSessionLayer = (formData?: FormData) => {
  const source_url = window.location.href;

  let uuid, formName, locale, sourceChannelCategory, sourceChannel, sourceChannelProvider, product;

  if (formData) {
    uuid = formData.uuid;
    formName = formData.formName;
    locale = formData.settings[0].locale;
    const crm = formData.settings[0].crm;

    if (crm && crm.length > 0) {
      const crmItem = crm[0];
      sourceChannelCategory = crmItem.sourceChannelCategory;
      sourceChannel = crmItem.sourceChannel;
      sourceChannelProvider = crmItem.sourceChannelProvider;
      product = crmItem.product;
    }
  }

  const existingSessionLayer = window.sessionLayer ?? {};
  const existingLead = existingSessionLayer.lead;

  window.sessionLayer = {
    pushToSession: pushToSessionLayer,
    lead: {
      form_client: { uuid, formName, locale },
      marketing_data: {
        source_channel_category: getAttribution("utm_channel_category") ?? existingLead?.marketing_data?.source_channel_category ?? sourceChannelCategory ?? null,
        source_channel: getAttribution("utm_medium") ?? existingLead?.marketing_data?.source_channel ?? sourceChannel ?? null,
        source_channel_provider: getAttribution("utm_source") ?? existingLead?.marketing_data?.source_channel_provider ?? sourceChannelProvider ?? null,
        source_url: source_url,
        product: existingLead?.marketing_data?.product ?? product ?? getProductFromUrl() ?? null,
        locale: locale ?? `de-DE`,
        ga_client_id: null,
      },
      push_data: existingLead?.push_data ?? [],
      lead_data: existingLead?.lead_data ?? [],
      id_: undefined,
    },
  };

  fetchGAClientId();
  

  return window.sessionLayer;
};

const getAttribution = (param: string) => {
  const params = qs.parse(window.location.search);
  let URLParam: string | Array<string> = params[param] as string | Array<string>;

  if(URLParam && URLParam instanceof Array){
    URLParam = String(URLParam.pop());
  }
  return URLParam;
}

const getProductFromUrl = () => {
  const path = window.location.pathname;
  const productSlugs = ["edera", "lutera", "mictera"];
  const product = productSlugs.find((slug) => path.includes(slug));
  return product;
};

const pushToSessionLayer = (crm_field: string, crm_value: CRMValue) => {
  const data: PushData = { crm_field, crm_value };
  const marketingDataFields = ["source_channel_category", "source_channel", "source_channel_provider", "product", "locale", "ga_client_id"];

  if (marketingDataFields.includes(crm_field)) {
    (window.sessionLayer.lead.marketing_data as Record<string, CRMValue>)[crm_field] = crm_value;
    if (crm_field !== "product") {
      return;
    }
  }

  // Replace an existing entry for this field instead of appending a duplicate.
  // Without this, re-answering a step via the Back button pushes a second
  // value (e.g. iciq_score) and consumers read the stale first one — so the
  // result never recalculates. (Mirrors handleDuplicateStep's update-or-push;
  // in the normal forward flow there are no duplicates, so behaviour is
  // unchanged for every form.)
  const existingIndex = window.sessionLayer.lead.push_data.findIndex(
    (entry) => entry.crm_field === crm_field
  );
  if (existingIndex > -1) {
    window.sessionLayer.lead.push_data[existingIndex] = data;
  } else {
    window.sessionLayer.lead.push_data.push(data);
  }
};
